import {searchWorkspace,searchResultHref} from './search-result-scope';
import { Link as RouterLink, NavLink as RouterNavLink, useLocation, type LinkProps, type NavLinkProps } from 'react-router';
import {safeWorkflowReturn,contextualRecordHref} from './workflow-context';
import { selectedBuilding, withBuildingScope } from './building-scope';

export function Link(props: LinkProps) {
  const location = useLocation();
  const to = typeof props.to === 'string' ? contextualRecordHref(props.to,location.pathname,location.search) : { ...props.to,
    search: new URL(contextualRecordHref(`${props.to.pathname ?? location.pathname}${props.to.search ?? ''}`,location.pathname,location.search), 'https://staff.invalid').search };
  const back=safeWorkflowReturn(new URLSearchParams(location.search).get('returnTo'));
  const workspace=searchWorkspace(location.pathname,location.search);
  const destination=to;
  return <RouterLink {...props} to={workspace&&back&&typeof destination==='string'&&destination.startsWith('/')&&!destination.startsWith('//')?searchResultHref(destination,back,workspace):destination} />;
}
export function NavLink(props: NavLinkProps) {
  const location = useLocation();
  const to = typeof props.to === 'string' ? withBuildingScope(props.to, selectedBuilding(location.pathname, location.search)) : props.to;
  return <RouterNavLink {...props} to={to} />;
}
